
import Button from '../base/Button';

export default function Header() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src="https://static.readdy.ai/image/32da3dbc6c077a42865d0d012e77efdf/a928ae752c1ca469c6e93cbddf564096.png" 
            alt="ZENAS" 
            className="h-20 w-20 object-contain"
          />
        </div>
        
        <Button onClick={scrollToOffer} size="md">
          Quero a Oferta
        </Button>
      </div>
    </header>
  );
}
